import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
} from './Explainer';

export const LandCoverChangeExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='land-cover-change-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('shared.ncaDetail.details.landCoverChange.howDoMeasureThis.title')}</ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy body={t('shared.ncaDetail.details.landCoverChange.howDoMeasureThis.body')} />
          </ExplainerBody>
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
